// extracted by mini-css-extract-plugin
export default {"mode-action":"GameModeActions_mode-action__w4KQH"};